// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2_FT2","col":"CardReaderDesc_col__OlNes","label":"CardReaderDesc_label__2DE2Y"};